import { CircularProgress, Grid, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import PageHeader from '../../components/shared/PageHeader';
import { APIHeader } from '../../index';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import { ListFilterTableGrid, homeButtonComponent } from '../../styles';
import { isEmptyObject } from '../../utils';
import Filter from '../ListTableAndTrackingFIle/Filter';
import ListTable from './ListTable';

//My to-do Page Component
const MyToDo = props => {
  const { apiConfig, userInfo, productFamilyList, errorInAPI } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const urlFilterRef = useRef(false);

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [siteListData, setSiteListData] = useState([]);
  const [statusListData, setStatusListData] = useState([]);
  const [filterProdFamData, setFilterProdFamData] = useState([]);
  const [filterSiteData, setFilterSiteData] = useState([]);
  const [filterStatusData, setFilterStatusData] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedStatus: '',
    selectedSites: '',
    selectedProductFamily: '',
  });
  const [columnOrderData, setColumnOrderData] = useState({
    columnId: '',
    order: '',
  });

  function filterCheckedItems(arr, key) {
    return arr
      .filter(item => item.checked)
      .map(item => item[key])
      .toString();
  }

  function getURLFilterData() {
    const searchParams = new URLSearchParams(location.search);
    const hasFilterParams =
      searchParams.has('productFilter') ||
      searchParams.has('sitesFilter') ||
      searchParams.has('statusFilter');

    if (!hasFilterParams) {
      return null;
    }

    return {
      selectedProductFamily: searchParams.get('productFilter') || '',
      selectedSites: searchParams.get('sitesFilter') || '',
      selectedStatus: searchParams.get('statusFilter') || '',
    };
  }

  function updateURLWithFilters({
    selectedProductFamily = '',
    selectedSites = '',
    selectedStatus = '',
  }) {
    const searchParams = new URLSearchParams(location.search);

    if (selectedProductFamily) {
      searchParams.set('productFilter', selectedProductFamily);
    } else {
      searchParams.delete('productFilter');
    }

    if (selectedSites) {
      searchParams.set('sitesFilter', selectedSites);
    } else {
      searchParams.delete('sitesFilter');
    }

    if (selectedStatus) {
      searchParams.set('statusFilter', selectedStatus);
    } else {
      searchParams.delete('statusFilter');
    }

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString() ? `?${searchParams.toString()}` : '',
      },
      { replace: true }
    );
  }

  useEffect(() => {
    if (!isEmptyObject(userInfo) && userInfo.userID && userInfo.userID !== '') {
      //Get the List of my to do list
      fetch(`${apiConfig.uiURL}api/FetchDetailsforAction`, {
        method: 'POST',
        headers: APIHeader(),
        body: JSON.stringify({
          userId: userInfo.userID.toString(),
          RequestURL: '',
        }),
      })
        .then(async response => {
          const data = await response.json();
          setListData(data);
          //Get the site list
          fetch(`${apiConfig.uiURL}api/SiteList`, {
            headers: APIHeader(),
          })
            .then(async response => {
              const data = await response.json();
              setSiteListData(data);
              //Get the status list
              fetch(`${apiConfig.uiURL}api/FetchListStatus`, {
                headers: APIHeader(),
              })
                .then(async response => {
                  const data = await response.json();
                  setStatusListData(data);
                  setIsLoading(false);
                })
                .catch(() => {
                  dispatch(
                    errorNotification({
                      hasErrorOccured: true,
                      message: t('error_message'),
                    })
                  );
                });
            })
            .catch(() => {
              dispatch(
                errorNotification({
                  hasErrorOccured: true,
                  message: t('error_message'),
                })
              );
            });
        })
        .catch(() => {
          dispatch(
            errorNotification({
              hasErrorOccured: true,
              message: t('error_message'),
            })
          );
        });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiConfig, userInfo]);

  useEffect(() => {
    if (productFamilyList && productFamilyList.length > 0) {
      setFilterProdFamData(
        productFamilyList.map(item => ({
          ...item,
          checked: true,
        }))
      );
    }
  }, [productFamilyList]);

  useEffect(() => {
    if (siteListData && siteListData.length > 0) {
      setFilterSiteData(
        siteListData.map(item => ({
          ...item,
          checked: true,
        }))
      );
    }
  }, [siteListData]);

  useEffect(() => {
    if (statusListData && statusListData.length > 0) {
      setFilterStatusData(
        statusListData.map(item => ({
          ...item,
          checked: item.Status !== 'Complete' && item.Status !== 'Cancelled',
        }))
      );
    }
  }, [statusListData]);

  useEffect(() => {
    const urlFilterData = getURLFilterData();

    if (
      urlFilterRef.current ||
      !urlFilterData ||
      !userInfo?.userID ||
      productFamilyList.length === 0 ||
      siteListData.length === 0 ||
      statusListData.length === 0
    ) {
      return;
    }

    urlFilterRef.current = true;

    const selectedProdFam = urlFilterData.selectedProductFamily
      ? urlFilterData.selectedProductFamily.split(',')
      : [];
    const selectedSites = urlFilterData.selectedSites
      ? urlFilterData.selectedSites.split(',')
      : [];
    const selectedStatus = urlFilterData.selectedStatus
      ? urlFilterData.selectedStatus.split(',')
      : [];

    setFilterProdFamData(
      productFamilyList.map(item => ({
        ...item,
        checked: selectedProdFam.includes(item.Name),
      }))
    );
    setFilterSiteData(
      siteListData.map(item => ({
        ...item,
        checked: selectedSites.includes(item.SiteName),
      }))
    );
    setFilterStatusData(
      statusListData.map(item => ({
        ...item,
        checked: selectedStatus.includes(item.Status),
      }))
    );

    setSelectedFilters(urlFilterData);
    setIsLoading(true);

    fetch(`${apiConfig.uiURL}api/FetchDetailsforAction`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        userId: userInfo.userID.toString(),
        RequestURL: '',
        filterStatus: urlFilterData.selectedStatus,
        filterSites: urlFilterData.selectedSites,
        filterProductFamily: urlFilterData.selectedProductFamily,
        sort:
          columnOrderData && columnOrderData.columnId
            ? columnOrderData.columnId
            : '',
        ascdesc:
          columnOrderData && columnOrderData.order ? columnOrderData.order : '',
      }),
    })
      .then(async response => {
        const data = await response.json();
        setListData(data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location.search,
    userInfo,
    productFamilyList,
    siteListData,
    statusListData,
    apiConfig,
  ]);

  useEffect(() => {
    if (
      selectedFilters.selectedStatus ||
      selectedFilters.selectedSites ||
      selectedFilters.selectedProductFamily ||
      filterProdFamData.length === 0 ||
      filterSiteData.length === 0 ||
      filterStatusData.length === 0
    ) {
      return;
    }

    const defaultFilters = {
      selectedStatus: filterCheckedItems(filterStatusData, 'Status'),
      selectedSites: filterCheckedItems(filterSiteData, 'SiteName'),
      selectedProductFamily: filterCheckedItems(filterProdFamData, 'Name'),
    };

    setSelectedFilters(defaultFilters);

    if (!getURLFilterData()) {
      updateURLWithFilters(defaultFilters);
    }
  }, [filterProdFamData, filterSiteData, filterStatusData, selectedFilters]);

  //Navigate to URL based on action to do
  const navigateToURL = url => {
    navigate(`${url}`);
  };

  //To handle the refresh button of Filter
  const onRefreshClick = filteredData => {
    setSelectedFilters(filteredData);
    updateURLWithFilters(filteredData);

    const selectedProdFam = filteredData.selectedProductFamily
      ? filteredData.selectedProductFamily.split(',')
      : [];
    const selectedSites = filteredData.selectedSites
      ? filteredData.selectedSites.split(',')
      : [];
    const selectedStatus = filteredData.selectedStatus
      ? filteredData.selectedStatus.split(',')
      : [];

    setFilterProdFamData(prev =>
      prev.map(item => ({
        ...item,
        checked: selectedProdFam.includes(item.Name),
      }))
    );
    setFilterSiteData(prev =>
      prev.map(item => ({
        ...item,
        checked: selectedSites.includes(item.SiteName),
      }))
    );
    setFilterStatusData(prev =>
      prev.map(item => ({
        ...item,
        checked: selectedStatus.includes(item.Status),
      }))
    );

    // Get the List of PECR based on selected filter
    fetch(`${apiConfig.uiURL}api/FetchDetailsforAction`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        userId: userInfo.userID.toString(),
        RequestURL: '',
        filterStatus: filteredData.selectedStatus,
        filterSites: filteredData.selectedSites,
        filterProductFamily: filteredData.selectedProductFamily,
        sort:
          columnOrderData && columnOrderData.columnId
            ? columnOrderData.columnId
            : '',
        ascdesc:
          columnOrderData && columnOrderData.order ? columnOrderData.order : '',
      }),
    })
      .then(async response => {
        const data = await response.json();
        setListData(data);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  //To handle the sorting of columns in List table
  const handleOrderChange = (columnId, order) => {
    setColumnOrderData({
      columnId: columnId,
      order: order,
    });
    // Get the List of PECR based on sorted column and order
    fetch(`${apiConfig.uiURL}api/FetchDetailsforAction`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        userId: userInfo.userID.toString(),
        RequestURL: '',
        sort: columnId,
        ascdesc: order,
        filterStatus: selectedFilters.selectedStatus,
        filterSites: selectedFilters.selectedSites,
        filterProductFamily: selectedFilters.selectedProductFamily,
      }),
    })
      .then(async response => {
        const data = await response.json();
        setListData(data);
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };

  return errorInAPI.hasErrorOccured ? (
    <ErrorAlert message={errorInAPI.message} />
  ) : (userInfo && userInfo.userId === '') || isLoading ? (
    <Grid style={homeButtonComponent}>
      <CircularProgress />
    </Grid>
  ) : userInfo?.active?.toString() === '1' &&
    userInfo?.userId?.toString() !== '0' &&
    userInfo?.userId !== null ? (
    <Grid className="">
      <PageHeader title={t('My_to_do_list')} />
      {/* <Grid>
        <h4 style={titleName}>{t('My_to_do_list')}</h4>
      </Grid> */}
      <section className="p-4">
        <Grid style={ListFilterTableGrid}>
          <Grid>
            {siteListData.length > 0 ? (
              <Filter
                productFamilyList={filterProdFamData}
                siteListData={filterSiteData}
                statusListData={filterStatusData}
                handleRefreshClick={onRefreshClick}
                filterMaxHeight={592}
              />
            ) : (
              <Grid style={homeButtonComponent} width={300}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
          {listData.length > 0 ? (
            <Grid>
              <ListTable
                rows={listData}
                navigateToURL={navigateToURL}
                orderHandler={handleOrderChange}
              />
            </Grid>
          ) : (
            <Grid style={homeButtonComponent}>
              <Typography style={{ padding: '10px', fontWeight: 'bold' }}>
                {t('No_action_expected')}
              </Typography>
            </Grid>
          )}
        </Grid>
      </section>
    </Grid>
  ) : (
    <Grid style={homeButtonComponent}>{t('No_active_user_message')}</Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    productFamilyList: state.pecrInfo.pecrData.productFamilyList,
    errorInAPI: state.errorNotification,
  };
};

export default connect(mapStateToProps, null)(MyToDo);
